import React, { useState, useEffect } from 'react';
import useToken from 'hooks/useToken';
import { useToast } from 'context/providers/ToastProvider';
import { Card, Col, OverlayTrigger, Row, Tooltip } from 'react-bootstrap';
import SeccionDatosCliente from '../SeccionDatosCliente';
import SeccionDatosLicencia from '../SeccionDatosLicencia';
import PropTypes from 'prop-types';
import classNames from 'classnames';

const SeccionPrincipalDatos = ({
    idLicencia,
    licencias,

    setProcesandoModal,
    procesandoModal,
    editar,
    setEditar,

    getInformacionDetalladaLicenciaByID,

    setPolizasRelacionadas,


    akasiaPOSWebPaquetes,
    
    infoSuscripcion

}) => {

    const [tipoLicencia, setTipoLicencia] = useState([]);
    const [usuariosNube, setUsuariosNube] = useState([]);
    const [cicloFacturacion, setCicloFacturacion] = useState([]);
    const [vendedores, setVendedores] = useState([]);
    const [datosPCLogin, setDatosPCLogin] = useState([]);
    const [jsonFile, setJsonFile] = useState(null);
    const [linkageStatus, setLinkageStatus] = useState(null);
    const [loadingLinkageStatus, setLoadingLinkageStatus] = useState(false);


    const { token } = useToken();
    const { showErrorToast, showInfoToast } = useToast();

    /**
     * Obtiene los datos básicos de la licencia
     */
    const getDatosBasicosLicencia = async () => {
        try {
            // setCargando(true);
            const response = await fetch(`/api/licencia/ObtenerSeccionDatosLicencia/?id=${idLicencia}`, {
                method: 'GET',
                headers:
                {
                    'Authorization': 'Bearer ' + token,
                    'Content-Type': 'application/json'
                }
            });

            if (!response.ok) {
                if (response.status === 401) {
                    localStorage.removeItem('token');
                    window.location.href = "";
                    return;
                }
                throw new Error(`${response.status} ${response.statusText}`);
            }

            const data = await response.json();
            //console.log(data, "DATA SECCION")


            if (data.iResponseType == 1) {

                var ObjDetalles = JSON.parse(data.detalles);

                console.log("Seccion Datos Principal", ObjDetalles)


                // Actualizar el estado con los datos obtenidos
                setTipoLicencia(ObjDetalles.table2);
                setCicloFacturacion(ObjDetalles.table3);
                setVendedores(ObjDetalles.table4);
                setDatosPCLogin(ObjDetalles.table5);
            }

        } catch (error) {
            showErrorToast(error.message);
            console.error('Error al obtener datos de la licencia:', error);
        } finally {
            //setCargando(false);
        }
    };

    const checkLinkageStatus = async () => {
        try {
            setLoadingLinkageStatus(true);

            const response = await fetch('/api/licencia/CheckLinkageStatus', {
                method: 'POST',
                headers: {
                    'Authorization': 'Bearer ' + token,
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({ idLicenciaNube: idLicencia })
            });

            if (!response.ok) {
                if (response.status === 401) {
                    localStorage.removeItem('token');
                    window.location.href = "";
                    return;
                }
                throw new Error(`${response.status} ${response.statusText}`);
            }

            const data = await response.json();
            console.log('Linkage status:', data);

            if (data.iResponseType === 1 && data.detalles) {
                const statusArray = JSON.parse(data.detalles);
                // Los datos vienen como array, tomar el primer elemento
                if (Array.isArray(statusArray) && statusArray.length > 0) {
                    setLinkageStatus(statusArray[0]);
                }
            }
        } catch (error) {
            console.error('Error checking linkage status:', error);
        } finally {
            setLoadingLinkageStatus(false);
        }
    };

    // Cargar datos al montar el componente
    useEffect(() => {
        getDatosBasicosLicencia();
        console.log("licencias", licencias)
        // Verificar estado de vinculación si es licencia tipo 3 o 7
        if (licencias.idCatTipoLicencia === 3 || licencias.idCatTipoLicencia === 7) {
            console.log("Entrando a checkLinkageStatus para tipo:", licencias.idCatTipoLicencia);
            checkLinkageStatus();
        }
    }, [idLicencia, licencias]);

    const generarVinculacion = async () => {
        try {
            setProcesandoModal(true);

            const response = await fetch('/api/licencia/GenerateLinkageData', {
                method: 'POST',
                headers: {
                    'Authorization': 'Bearer ' + token,
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({ vLicenseLink: idLicencia })
            });

            if (!response.ok) {
                if (response.status === 401) {
                    localStorage.removeItem('token');
                    window.location.href = "";
                    return;
                }
                throw new Error(`${response.status} ${response.statusText}`);
            }

            const data = await response.json();
            console.log('Linkage data generated:', data);

            if (data.iResponseType === 1) {
                // Descargar el archivo JSON con los detalles
                if (data.detalles) {
                    const detallesData = JSON.parse(data.detalles);
                    const jsonString = JSON.stringify(detallesData, null, 2);
                    const blob = new Blob([jsonString], { type: 'application/json' });
                    const url = window.URL.createObjectURL(blob);
                    const link = document.createElement('a');
                    link.href = url;
                    link.download = `vinculacion_${idLicencia}.json`;
                    document.body.appendChild(link);
                    link.click();
                    document.body.removeChild(link);
                    window.URL.revokeObjectURL(url);
                }
                showInfoToast('Vinculación generada exitosamente');
            } else {
                showErrorToast(data.vMessage || 'Error al generar vinculación');
            }
        } catch (error) {
            showErrorToast(error.message);
            console.error('Error generating linkage:', error);
        } finally {
            setProcesandoModal(false);
        }
    };

    const autoLinkLicenses = async () => {
        try {
            if (!jsonFile) {
                showErrorToast('Por favor selecciona un archivo JSON');
                return;
            }

            setProcesandoModal(true);

            // Leer el archivo JSON
            const fileContent = await jsonFile.text();
            const jsonData = JSON.parse(fileContent);

            if (!Array.isArray(jsonData) || jsonData.length === 0) {
                showErrorToast('El archivo JSON debe contener un array con datos');
                return;
            }

            // Obtener el primer elemento del array
            const linkData = jsonData[0];
            const idLicenciaPOSWeb = linkData.idLicenciaPOSWeb;
            const vBDPOSWeb = linkData.vBDPOSWeb;

            const response = await fetch('/api/licencia/AutoLinkLicenses', {
                method: 'POST',
                headers: {
                    'Authorization': 'Bearer ' + token,
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({
                    idLicenciaNube: parseInt(idLicencia),
                    idLicenciaPOSWeb: idLicenciaPOSWeb,
                    vBDPOSWeb: vBDPOSWeb
                })
            });

            if (!response.ok) {
                if (response.status === 401) {
                    localStorage.removeItem('token');
                    window.location.href = "";
                    return;
                }
                throw new Error(`${response.status} ${response.statusText}`);
            }

            const data = await response.json();
            console.log('AutoLink response:', data);

            if (data.iResponseType === 1) {
                showInfoToast('Vinculación automática completada exitosamente');
                setJsonFile(null);
                // Recargar estado de vinculación
                checkLinkageStatus();
            } else {
                showErrorToast(data.vMessage || 'Error al vincular licencias');
            }
        } catch (error) {
            showErrorToast(error.message);
            console.error('Error in autoLinkLicenses:', error);
        } finally {
            setProcesandoModal(false);
        }
    };


    return (
        <Row className="g-3 mb-3">
            <Col lg={6}>
                <SeccionDatosLicencia
                    idLicencia={idLicencia}
                    licencias={licencias}

                    setProcesandoModal={setProcesandoModal}
                    procesandoModal={procesandoModal}
                    editar={editar}
                    setEditar={setEditar}

                    getInformacionDetalladaLicenciaByID={getInformacionDetalladaLicenciaByID}

                    vendedores={vendedores}

                    tipoLicencia={tipoLicencia}

                    cicloFacturacion={cicloFacturacion}

                    setPolizasRelacionadas={setPolizasRelacionadas}

                    usuariosNube={usuariosNube}
                    setUsuariosNube={setUsuariosNube}

                    akasiaPOSWebPaquetes={akasiaPOSWebPaquetes}
                    
                    infoSuscripcion={infoSuscripcion}
                ></SeccionDatosLicencia>
            </Col>
            <Col lg={6}>
                <SeccionDatosCliente
                    licencias={licencias}
                    idLicencia={idLicencia}

                    getInformacionDetalladaLicenciaByID={getInformacionDetalladaLicenciaByID}

                    usuariosNube={usuariosNube}
                    setUsuariosNube={setUsuariosNube}
                    
                    infoSuscripcion={infoSuscripcion}
                />
                {licencias.idCatTipoLicencia != 3 && licencias.idCatTipoLicencia != 7 &&
                    <Card className="fs--1">
                        <Card.Header>
                            <h5>&Uacute;ltimos inicios de sesi&oacute;n</h5>
                        </Card.Header>
                        <Card.Body className="border-top">
                            {datosPCLogin.map((log, index) => (
                                <Row
                                    key={index}
                                    className="g-0 align-items-center border-bottom px-3" >
                                    <Col md="auto" className="pe-3">
                                        <span className={classNames('badge rounded-pill', 'badge-soft-success')}>
                                            {log.vIpPublica}
                                        </span>
                                    </Col>
                                    <Col>
                                        {log.vMachineName}
                                    </Col>
                                    <Col md>
                                        <code>
                                            {log.vVersion}
                                        </code>
                                    </Col>
                                    <Col>
                                        &nbsp;<OverlayTrigger
                                            placement="top"
                                            overlay={
                                                <Tooltip style={{ position: 'fixed' }} >
                                                    <strong>{log.vDatosPcLogIn}</strong>
                                                </Tooltip>
                                            }
                                        >
                                            <img src="/img/pcautorizada25.png"></img>
                                        </OverlayTrigger>
                                        &nbsp;<OverlayTrigger
                                            placement="top"
                                            overlay={
                                                <Tooltip style={{ position: 'fixed' }} >
                                                    <strong>{log.vConectionString}</strong>
                                                </Tooltip>
                                            }
                                        >
                                            <img src="/img/servidor25.png"></img>
                                        </OverlayTrigger>
                                        &nbsp;{log.vLatLonSistema && <OverlayTrigger
                                            placement="top"
                                            overlay={
                                                <Tooltip style={{ position: 'fixed' }} >
                                                    <strong>{log.vLatLonSistema}</strong>
                                                </Tooltip>
                                            }
                                        >
                                            <a href={"https://www.google.com/maps/place/" + log.vLatLonSistema} target="_blank" rel="noreferrer"><img src="/img/ubicacion25.png"></img></a>
                                        </OverlayTrigger>}
                                    </Col>
                                    <Col md="auto">
                                        {log.dCreatedDate}
                                    </Col>
                                </Row>
                            ))}
                        </Card.Body>
                    </Card>
                }
                {licencias.idCatTipoLicencia === 3 &&
                    <Card className="fs--1">
                        <Card.Header>
                            <h5>Vinculaci&oacute;n de Akasia POS Web a Nube</h5>
                        </Card.Header>
                        <Card.Body className="border-top">
                            {loadingLinkageStatus ? (
                                <div className="text-center py-3">
                                    <div className="spinner-border spinner-border-sm" role="status">
                                        <span className="visually-hidden">Cargando...</span>
                                    </div>
                                </div>
                            ) : linkageStatus?.bIsLinked ? (
                                <div>
                                    <div className="alert alert-success mb-3">
                                        <strong>Estado:</strong> {linkageStatus.vEstadoVinculacion}
                                    </div>
                                    <p className="mb-2"><strong>Mensaje:</strong> {linkageStatus.vMensaje}</p>
                                    <p className="mb-2"><strong>ID Cliente Akasia:</strong> {linkageStatus.idClienteAkasia}</p>
                                </div>
                            ) : (
                                <Row className="g-3">
                                    <Col xs={12}>
                                        <p className="mb-3 text-muted">
                                            Al vincular, los datos de la licencia POS Web se sincronizar&aacute;n con esta licencia Nube en su Akasia Desktop.
                                        </p>
                                        <label className="form-label">Archivo JSON de Vinculaci&oacute;n</label>
                                        <input
                                            type="file"
                                            className="form-control"
                                            accept=".json"
                                            onChange={(e) => setJsonFile(e.target.files[0])}
                                            disabled={procesandoModal}
                                        />
                                        {jsonFile && (
                                            <small className="text-muted d-block mt-1">
                                                Archivo seleccionado: {jsonFile.name}
                                            </small>
                                        )}
                                    </Col>
                                    <Col xs={12}>
                                        <button
                                            className="btn btn-success w-100"
                                            onClick={autoLinkLicenses}
                                            disabled={procesandoModal || !jsonFile}
                                        >
                                            {procesandoModal ? 'Procesando...' : 'Vincular Licencias'}
                                        </button>
                                    </Col>
                                </Row>
                            )}
                        </Card.Body>
                    </Card>
                }
                {licencias.idCatTipoLicencia === 7 &&
                    <Card className="fs--1">
                        <Card.Header>
                            <h5>Vinculaci&oacute;n de AkasiaPos</h5>
                        </Card.Header>
                        <Card.Body className="border-top">
                            {loadingLinkageStatus ? (
                                <div className="text-center py-3">
                                    <div className="spinner-border spinner-border-sm" role="status">
                                        <span className="visually-hidden">Cargando...</span>
                                    </div>
                                </div>
                            ) : linkageStatus?.bIsLinked ? (
                                <div>
                                    <div className="alert alert-success mb-3">
                                        <strong>Estado:</strong> {linkageStatus.vEstadoVinculacion}
                                    </div>
                                    <p className="mb-2"><strong>Mensaje:</strong> {linkageStatus.vMensaje}</p>
                                    <p className="mb-3"><strong>ID Cliente Akasia:</strong> {linkageStatus.idClienteAkasia}</p>
                                </div>
                            ) : (
                                <Row className="g-3">
                                    <Col xs={12}>
                                        <button
                                            className="btn btn-primary w-100"
                                            onClick={generarVinculacion}
                                            disabled={procesandoModal}
                                        >
                                            {procesandoModal ? 'Procesando...' : 'Generar Vinculaci\u00f3n'}
                                        </button>
                                    </Col>
                                </Row>
                            )}
                        </Card.Body>
                    </Card>
                }
            </Col>
        </Row>
    );
};


SeccionPrincipalDatos.propTypes = {
    idLicencia: PropTypes.string.isRequired,
    licencias: PropTypes.object.isRequired,

    setProcesandoModal: PropTypes.func.isRequired,
    procesandoModal: PropTypes.bool.isRequired,
    editar: PropTypes.bool.isRequired,
    setEditar: PropTypes.func.isRequired,

    getInformacionDetalladaLicenciaByID: PropTypes.func.isRequired,

    setPolizasRelacionadas: PropTypes.func.isRequired,

    akasiaPOSWebPaquetes: PropTypes.array.isRequired,

    infoSuscripcion: PropTypes.object,

};

export default SeccionPrincipalDatos; 